export const PHOTO_LIST_RESOURCE_URL = 'https://family-photo-runtak-reduction.s3.ap-northeast-1.amazonaws.com'
export const PHOTO_RESOURCE_BASE_URL = 'https://family-photo-runtak.s3.ap-northeast-1.amazonaws.com'
export const PHOTO_SECONDARY_RESOURCE_BASE_URL = 'https://family-photo-runtak-upload.s3.ap-northeast-1.amazonaws.com'

export const API_BASE_URL = 'https://eozafxffoetcgzhq6vr7pvj7oq0isygb.lambda-url.ap-northeast-1.on.aws'

// 開発用API確認用 ($LATEST)
//export const API_BASE_URL = 'https://yxc5yf7m7kmzcovtsxxzyx2mxi0euydk.lambda-url.ap-northeast-1.on.aws'

export const HOME_PATH = '/index.html'
export const ARTICLE_PATH = '/article'
export const PHOTO_DISPLAY_PATH = '/display'
export const UPLOAD_PATH = '/upload'
export const EDIT_PATH = '/edit'
export const ACTIVITY_PATH = '/activity'
export const TIME_DIFFERENCE = ':00-08:00'

// parameter before operation
export const VERSION = '1.0.4'